<template>
  <section class="input-richt-text">
    <section class="editor" v-if="value">
      <div class="atom" v-for="(component, index) in value" :key="`${unique}${component.type}${component.id}`">
        <component v-if="unique"
          :is="component.type" :cid="component.id" v-model="component.props"
          :key="`Component${unique}${component.type}${component.id}`"
          @meta="$set(editMetaVisible, index, true)"
          :edit="editAtomVisible[index]">
        </component>


        <div class="more">
          <span v-if="!editAtomVisible[index]" @click="$set(editAtomVisible, index, !editAtomVisible[index])"><i class="el-icon-more-outline"/></span>
          <span v-else @click="$set(editAtomVisible, index, !editAtomVisible[index])"><i class="el-icon-close"/></span>
          <span @click="removeAtom(index)"><i class="el-icon-delete"/></span>
          <span @click="$set(addAtomVisible, index, true)"><i class="el-icon-circle-plus-outline"/></span>
        </div>

        <el-dialog title="Tag optionnel" :visible.sync="editMetaVisible[index]" :append-to-body="true">
          <div class="add-meta" v-if="component.props">
            <p>
              Ce paramètre peut vous permettre d'identifier un élément du contenu éditable plus facilement.
            </p>
            <el-input class="meta" v-model="component.props.meta" size="mini" placeholder="Tag optionnel"></el-input>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="editMetaVisible[index] = false" size="small">Fermer</el-button>
          </span>
        </el-dialog>

        <el-dialog title="Ajouter un élément" :visible.sync="addAtomVisible[index]" :append-to-body="true">
          <el-radio-group v-model="position" size="mini">
            <el-radio-button label="after">Après l'élément</el-radio-button>
            <el-radio-button label="before">Avant l'élément</el-radio-button>
          </el-radio-group>
          <div class="add-element">
            <span @click="addAtom('AtomText', index + 1)"><i class="material-icons">short_text</i><br>Texte</span>
            <span @click="addAtom('AtomImage', index + 1)"><i class="material-icons">insert_photo</i><br>Image</span>
            <span @click="addAtom('AtomGrid', index + 1)"><i class="material-icons">dashboard</i><br>Grille</span>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="addAtomVisible[index] = false" size="small">Annuler</el-button>
          </span>
        </el-dialog>

      </div>

    </section>

  </section>
</template>

<script>
import AtomText from './richtext-atoms/AtomText.vue';
import AtomImage from './richtext-atoms/AtomImage.vue';
import AtomGrid from './richtext-atoms/AtomGrid.vue';

export default {
  name: 'input-richt-text',
  components: {
    AtomText,
    AtomImage,
    AtomGrid,
  },
  props: ['value'],
  data() {
    return {
      unique: Math.floor(Math.random() * Math.floor(100000)),
      addAtomVisible: {},
      editMetaVisible: {},
      editAtomVisible: {},
      removeAtomVisible: {},
      position: 'after',
    };
  },
  created() {
    this.initData();
  },
  watch: {
    value: 'initData',
  },
  methods: {
    initData() {
      if (this.value && this.value.length === 0) {
        this.addAtom('AtomText', 0);
      }
    },
    addAtom(atomType, i) {
      const index = (this.position === 'after') ? i : i - 1;
      this.value.splice(index, 0, {});
      this.$set(this.value, index, { id: Math.floor(Math.random() * Math.floor(100000)), type: atomType, props: {} });
      this.$emit('input', this.value);
      this.addAtomVisible[i - 1] = false;
      this.$forceUpdate();
    },
    async removeAtom(index) {
      try {
        await this.$confirm('Voulez-vous bien supprimer cet élément ?', 'Suppresion de l’élement');
        if (this.value.length > 1) {
          this.value.splice(index, 1);
          this.$emit('input', this.value);
          this.$forceUpdate();
        } else {
          this.$message({
            type: 'error',
            message: 'Impossible de supprimer le dernier élément',
          });
        }
      } catch (error) {
        // Rien à faire mais le linter est penible
      }
    },
  },
};
</script>

<style lang="sass">
.input-richt-text
  background: white
  div
    box-sizing: border-box

  .atom
    position: relative
    margin: 0.5rem 0
    padding-right: 50px
    min-height: 110px
    border-left: 4px solid transparent
    transition: all ease-in 0.2s
    background: #FAFAFA

    .more
      position: absolute
      right: 0
      top: 0
      bottom: 0
      padding: 0.5rem
      background: #DADADA
      > span
        display: block
        padding: 0.4rem
        background: white
        font-size: 0.7rem
        & ~ span
          margin-top: 0.2rem

    .edit
      position: absolute
      top: 0
      left: 0
      right: 40px
      display: flex
      text-align: left
      padding: 0.45rem 0.5rem 0.3rem
      background: #EAEAEA
      .meta
        margin-right: 4px
        width: 110px
      i
        font-size: 16px
      .el-button-group
        display: flex
        flex: 1 1 0
        .el-button+.el-button
          margin: 0
      .edit-atom
        display: flex
        flex: 1 1 0
        justify-content: flex-end
      ~ div
        margin-top: 50px
      button, .el-radio-button__inner
        padding: 0.4rem 0.4rem 0.3rem
      .el-radio-group
        .el-radio-button
          display: inline-block
          margin: 0
          padding: 0
          &:focus
            outline: 0

    &:hover
      border-left: 4px solid #EAEAEA
      background: #fafafa

  &:hover
    > .editor > .add-one
      display: block

.add-element
  margin-top: 2rem
  span
    display: inline-block
    margin: 1rem
    padding: 2.5rem 3rem
    border: 1px solid #DDDDDD
    border-radius: 4px
    background: #FAFAFA
    cursor: pointer
    i
      margin-bottom: 0.5rem

.add-meta
  .el-input
    width: 60%
</style>
